import axios from 'axios';
import queryString from "query-string";
import loadConfig from '../apiService';
import { decryptToken, encryptToken } from './EncryptionToken';
import { jwtDecode } from 'jwt-decode';

const LogInServices = async () => {
    let config = await loadConfig();
    let userToken = "";

    try {
        const urlParams = new URLSearchParams(window.location.search);
        const myParams = urlParams.get("code");
        // Check if tokens are stored in sessionStorage instead of cookies
        if ((!sessionStorage.getItem("Refreshtoken") && !sessionStorage.getItem("AccessToken")) && (myParams != null || myParams != undefined)) {
            // Obtain tokens via OAuth
            const result = await axios.post('https://login.shoman.org/oauth2/token',
                queryString.stringify({
                    client_id: config.client_id,
                    scope: "user.read",
                    code: myParams,
                    redirect_uri: config.redirect_uri,
                    grant_type: "authorization_code",
                    client_secret: config.client_secret,
                }), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            // Perform login on your backend
            const loginResult = await axios.post(`${config.domainUrl}/api/Account/Login`, {
                nameSso: "externale",
                token: result.data.access_token,
            });

            // Store tokens in sessionStorage instead of cookies
            var userInfo = jwtDecode(loginResult.data.result.refreshToken)
            //     dispatch(SetDataUser(userInfo))
            var refreshToken = encryptToken(loginResult.data.result.refreshToken)
            var AccessToken = encryptToken(loginResult.data.result.accessToke)
            sessionStorage.setItem("Refreshtoken", refreshToken);
            sessionStorage.setItem("AccessToken", AccessToken);
            sessionStorage.setItem("Code", myParams);
            userToken = userInfo;

            window.location.replace(config.redirect_uri+"mainpage/");

        } else if (sessionStorage.getItem("Refreshtoken") && sessionStorage.getItem("AccessToken")) {
            userToken = jwtDecode(decryptToken("AccessToken","sso"));
        }else {

            window.location.replace(config.ssoUrl);
        }

    } catch (err) {
        //console.log("catch", err);
    }
    return {userToken:userToken,login:"sso"};

}

export default LogInServices;
